import React from 'react'

export default function H2({text}) {
  return   (
    <div>
        <h2>{text}</h2>
    </div>
  )
}
